import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

export interface BillingToggleProps {
  value: 'monthly' | 'yearly'
  onChange: (value: 'monthly' | 'yearly') => void
  discount?: number
  className?: string
}

export const BillingToggle: React.FC<BillingToggleProps> = ({
  value,
  onChange,
  discount,
  className,
}) => {
  const { t } = useTranslation()
  const isYearly = value === 'yearly'

  return (
    <div className={cn('flex items-center justify-center gap-3', className)}>
      <div className="inline-flex items-center rounded-full border border-border bg-muted/40 p-1">
        <button
          type="button"
          onClick={() => onChange('monthly')}
          className={cn(
            'rounded-full px-5 py-2 text-sm font-medium transition-all duration-200',
            !isYearly
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {t('publicPlans.billing.monthly')}
        </button>
        <button
          type="button"
          onClick={() => onChange('yearly')}
          className={cn(
            'rounded-full px-5 py-2 text-sm font-medium transition-all duration-200',
            isYearly
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {t('publicPlans.billing.yearly')}
        </button>
      </div>
      {discount != null && discount > 0 && (
        <span className="inline-flex items-center rounded-full bg-emerald-500/10 px-3 py-1.5 text-xs font-bold text-emerald-600 dark:text-emerald-400">
          {t('publicPlans.badges.saveUpTo', { discount })}
        </span>
      )}
    </div>
  )
}
